import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import {
  ButtonModule,
  HighlightTextModule,
  HrModule,
  NavButtonModule,
  NavListButtonModule,
  SvgIconModule
} from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

import { SearchCategoriesComponent } from './search-categories.component';

@NgModule({
  declarations: [SearchCategoriesComponent],
  imports: [
    CommonModule,
    TranslationModule,
    ButtonModule,
    NavButtonModule,
    NavListButtonModule,
    HrModule,
    SvgIconModule,
    HighlightTextModule,
    AnalyticsModule
  ],
  exports: [SearchCategoriesComponent]
})
export class SearchCategoriesModule {}
